export const stats: Record<string, string> = {
	stats_sectionCombat: "Combat",
	stats_sectionExploration: "Exploration",
	stats_sectionItems: "Items",
	stats_sectionSurvival: "Survival",
	stats_sectionHighlights: "Highlights",
	stats_labelMobsKilled: "Mobs killed",
	stats_labelDamageReceived: "Damage received",
	stats_labelShotsFired: "Shots fired",
	stats_labelTurnsElapsed: "Turns",
	stats_labelTilesWalked: "Tiles walked",
	stats_labelLevelsVisited: "Levels visited",
	stats_labelFavoriteLevel: "Favorite level",
	stats_labelAmmoCollected: "Ammo collected",
	stats_labelContainersOpened: "Containers opened",
	stats_labelObstaclesDestroyed: "Obstacles destroyed",
	stats_labelLowestHp: "Lowest HP",
	stats_labelHealingReceived: "Healing received",
	stats_labelCauseOfDeath: "Cause of death",
	stats_labelMostUsedWeapon: "Most used weapon",
	stats_labelMostLethalWeapon: "Most lethal",
	stats_labelGameStarted: "Game started",
	stats_labelRunDuration: "Run duration",
};
